import * as React from 'react'

const defaultSize = {
  x: 20,
  y: 20,
}

export interface IProps {
  size?: { x: number; y: number }
  style?: React.CSSProperties
}
export const Position: React.FCC<IProps> = ({ size = defaultSize, style }) => (
  <svg
    width={size.x}
    height={size.y}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <path
      d="M8 4L6.4 5.6M8 4l1.6 1.6M8 4v8m0 0l1.6-1.6M8 12l-1.6-1.6M4 8l1.6 1.6M4 8l1.6-1.6M4 8h8m0 0l-1.6-1.6M12 8l-1.6 1.6"
      stroke="var(--figma-color-text, rgba(0, 0, 0, 0.8))"
    />
  </svg>
)
